import styled from 'styled-components';
import DefaultClose from '../../svgs/Close';
import Text from '../../dumbs/Text';
import { MainProps } from './types';

export const Main = styled.div<MainProps>`
  max-width: 50%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: row;
  margin-left: ${({ theme, $marginLeft }) =>
    !!$marginLeft ? $marginLeft : theme.spacing.km0};
  background-color: ${({ theme }) => theme.color.background.danger.weak};
  padding: ${({ theme }) => theme.spacing.km4}
    ${({ theme }) => theme.spacing.km6};
  border-radius: ${({ theme }) => theme.border.radius.large};
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    max-width: 100%;
    margin-top: ${({ theme }) => theme.spacing.km12};
  }
`;

export const Container = styled.div`
  width: 96%;
  overflow-wrap: break-word;
  flex: 1;
`;

export const TextComponent = styled(Text)`
  color: ${({ theme }) => theme.color.text.neutral.strong};
  margin-left: ${({ theme }) => theme.spacing.km4};
  line-height: ${({ theme }) => theme.font.lineHeight.small};
  flex: 1;
  letter-spacing: -0.03em;
`;

export const Close = styled(DefaultClose)`
  cursor: pointer;
  margin-left: ${({ theme }) => theme.spacing.km6};
  color: ${({ theme }) => theme.color.icon.neutral.default};
`;
